// Minimal local stub for `prop-types` to avoid bundling the real package.
// Provides validators that always pass (return null), matching the expected
// function signatures for both primitives and creator validators.

const returnNull = () => null;

// Primitive validators should be functions that return null when invoked.
const primitive = returnNull;

// Creator validators should accept an argument and return a validator
// function that returns null when invoked.
const creator = () => returnNull;

const PropTypes = {
  array: primitive,
  bool: primitive,
  func: primitive,
  number: primitive,
  object: primitive,
  string: primitive,
  node: primitive,
  element: primitive,
  symbol: primitive,
  any: primitive,
  arrayOf: creator,
  objectOf: creator,
  oneOf: creator,
  oneOfType: creator,
  shape: creator,
  exact: creator,
  instanceOf: creator,
};

export default PropTypes;
export const checkPropTypes = () => {};
